export default {
  "guide": "_guide_1fm0o2 body-2",
  "icon": "_icon_1fm0o2",
  "active": "_active_1fm0o2"
};